import React from 'react';
import {Box, capitalize, Grid, Typography} from '@mui/material';

export default function officeColumn(providers) {
    return {
        name: 'name',
        setBodyRowProps: () => ({ sx: { p: 0, backgroundColor: 'primary.main' } }),
        setBodyCellProps: () => ({
            sx: {
                verticalAlign: 'top',
                p: 1,
                pl: 2,
                backgroundColor: 'primary.main',
                border: 0,
                userSelect: 'none',
                cursor: 'default',
                position: 'sticky',
                top: 0,
                left: 0,
                zIndex: '150 !important',
            },
        }),
        render: office => <Grid container>
            <Grid
                item
                xs={6}
                sx={{
                    display: 'flex',
                    alignItems: 'start',
                    justifyContent: 'center',
                    color: 'secondary.contrastText',
                }}
            >
                <Box sx={{ width: '100%' }}>
                    <Typography  sx={{ textAlign: 'left' }} variant="subtitle1" fontWeight={600}>
                        {office}
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'start', flexDirection: 'column', gap: 1 }}>
                    {providers.map((provider, index) => (
                        <Box sx={{ p: 1, height: 55 }} >
                            <Typography
                                key={`${provider}-${index}`}
                                variant="body2"
                                sx={{
                                    color: 'secondary.contrastText',
                                    textAlign: 'left',
                                    fontWeight: 'bold'
                                }}
                            >
                                {capitalize(provider)}
                            </Typography>
                        </Box>
                    ))}
            </Grid>
        </Grid>
    };
}
